import { ReportFeatures } from '@hcs/types';

export const COMP_SUMMARY_MAP_FEATURES_SALE = [
  ReportFeatures.CompsHcSuggested,
  ReportFeatures.CompsSelect,
];
export const COMP_SUMMARY_MAP_FEATURES_RENTAL = [
  ReportFeatures.RentalCompsHcSuggested,
  ReportFeatures.RentalCompsSelect,
];
export const COMP_SUMMARY_MAP_ID = 'COMP_SUMMARY_MAP_ID';
